import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Clock, ShieldCheck, LayoutList } from 'lucide-react';
export function SystemOverview() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  const benefits = [{
    icon: <Clock className="w-8 h-8 text-terracotta" data-id="element-146" />,
    title: 'RECUPERÁS TU PAZ',
    description: 'En solo 7 días vas a ver cómo el clima de tu casa cambia. Sabés qué decir para cerrar el conflicto en 2 minutos y abrir la confianza.'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-terracotta" data-id="element-147" />,
    title: 'VOLVÉS A SER SU LUGAR SEGURO',
    description: 'Aprendés a desarmar la rebeldía sin gritar ni perder tu autoridad. Ya no sos "la que molesta", sos la persona en la que él confía.'
  }, {
    icon: <LayoutList className="w-8 h-8 text-terracotta" data-id="element-148" />,
    title: 'ESTRUCTURA REAL',
    description: 'No es teoría de libros. Son acciones concretas y validadas clínicamente para cada uno de los 7 días de la semana, listas para aplicar.'
  }];
  return <section className="bg-cream py-20 px-4 md:px-8 lg:px-16" data-id="element-149">
      <div className="max-w-5xl mx-auto" data-id="element-150">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="text-center mb-16" data-id="element-151">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-152">
            UN SISTEMA QUE TE SOSTIENE (Y TE DA EL CONTROL)
          </motion.h2>
          <motion.p variants={itemVariants} className="text-xl text-terracotta font-medium mb-6" data-id="element-153">
            Pack Reconexión Familiar Total™ (Guía Práctica)
          </motion.p>
          <motion.p variants={itemVariants} className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-154">
            Hemos creado un sistema táctico paso a paso para que dejes de
            "adivinar" cómo hablarle y empieces a liderar la relación con
            herramientas clínicas y prácticas basadas en la neurobiología del
            adolescente.
          </motion.p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-155">
          {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-8 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-300" data-id="element-156">
              <div className="bg-cream w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto" data-id="element-157">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-navy mb-4 text-center" data-id="element-158">
                {benefit.title}
              </h3>
              <p className="text-gray-600 text-center leading-relaxed" data-id="element-159">
                {benefit.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}